import { render, staticRenderFns } from "./service-locations-disclaimers-card.vue?vue&type=template&id=673d92cc&scoped=true&"
import script from "./service-locations-disclaimers-card.vue?vue&type=script&lang=js&"
export * from "./service-locations-disclaimers-card.vue?vue&type=script&lang=js&"
import style0 from "./service-locations-disclaimers-card.vue?vue&type=style&index=0&id=673d92cc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "673d92cc",
  null
  
)

export default component.exports